import { combineReducers } from 'redux'
import changeRequest from './changeRequest.reducer'

export default combineReducers({
  changeRequest
})
